(function () {
  'use strict';
  var d = document;
  function $(s) { return d.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(d.querySelectorAll(s)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  // Every handler is DELEGATED from document. The colour selector re-renders the
  // thumbs, size buttons and sticky options in place, and a directly-bound
  // listener would die with the node it was bound to.
  var firstAdd = $('[data-kp-add]');
  var selected = firstAdd ? firstAdd.getAttribute('data-variant') : null;

  function setVariant(id, priceCents) {
    selected = id;
    $$('[data-kp-add]').forEach(function (b) { b.setAttribute('data-variant', id); });
    if (priceCents != null && !isNaN(priceCents)) {
      var p = $('[data-kp-price]'); if (p) p.textContent = money(priceCents);
      var sp = $('[data-kp-sticky-price]'); if (sp) sp.textContent = money(priceCents);
    }
  }

  function markSize(id) {
    $$('[data-kp-sizes] .kp-size').forEach(function (x) { x.classList.toggle('active', x.getAttribute('data-kp-variant') === String(id)); });
  }

  /* ---------------------------------------------------------------- *
   * colour group — sibling colourway PRODUCTS on one page            *
   * (sections/main-product.liquid, setting colour_group). Each       *
   * colour is its own product, so a swap only changes which real     *
   * variant the add buttons carry; kpAddVariant does the rest.       *
   * ---------------------------------------------------------------- */
  var group = null;
  try {
    var gs = $('[data-kp-colour-group]');
    group = gs ? JSON.parse(gs.textContent) : null;
  } catch (e) { group = null; }
  var activeHandle = (function () {
    var a = $('[data-kp-colour].active');
    return a ? a.getAttribute('data-kp-colour') : null;
  })();
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var swipeEnd = null;

  function byHandle(h) {
    for (var i = 0; group && i < group.length; i++) if (group[i].handle === h) return i;
    return -1;
  }

  // Slide the new colour's lead photo in from the side it sits on in the
  // selector. Waits for the image to decode (bounded) so it never slides in blank.
  function swipeTo(p, dir) {
    var box = $('.kp-gallery__main');
    var old = $('#kpMainImg');
    var img = p.images[0];
    if (!box || !old || !img) return;
    if (swipeEnd) swipeEnd();               // a tap mid-swipe finishes the last one first
    old = $('#kpMainImg');

    var nu = old.cloneNode(false);
    nu.removeAttribute('fetchpriority');
    nu.setAttribute('loading', 'eager');
    nu.src = img.src;
    nu.alt = p.title;

    function go() {
      if (reduceMotion) { old.parentNode.replaceChild(nu, old); return; }
      old.removeAttribute('id');
      box.classList.add('kp-swiping');
      nu.style.transform = 'translateX(' + (dir * 100) + '%)';
      box.appendChild(nu);
      nu.getBoundingClientRect();           // commit the start position before transitioning
      old.style.transform = 'translateX(' + (-dir * 100) + '%)';
      nu.style.transform = 'translateX(0)';
      var t = setTimeout(done, 420);
      function done() {
        clearTimeout(t);
        if (old.parentNode) old.parentNode.removeChild(old);
        nu.style.transform = '';
        box.classList.remove('kp-swiping');
        swipeEnd = null;
      }
      swipeEnd = done;
    }
    var ready = nu.decode ? nu.decode() : Promise.resolve();
    Promise.race([ready, new Promise(function (r) { setTimeout(r, 700); })]).then(go, go);
  }

  function renderThumbs(p) {
    var box = $('[data-kp-thumbs]');
    if (!box) return;
    box.hidden = p.images.length < 2;
    box.innerHTML = p.images.map(function (im, i) {
      return '<button type="button" class="kp-thumb' + (i ? '' : ' active') + '" data-kp-thumb="' + esc(im.src) + '" aria-label="view ' + (i + 1) + '">' +
        '<img src="' + esc(im.thumb) + '" alt="' + esc(p.title) + ' view ' + (i + 1) + '" width="200" height="200" loading="lazy"></button>';
    }).join('');
  }

  // Keep the shopper's size across colours when that size is in stock;
  // otherwise fall to the first size that is.
  function renderSizes(p, keepTitle) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var pick = avail.filter(function (v) { return v.title === keepTitle; })[0] || avail[0] || p.variants[0];
    var box = $('[data-kp-sizes]');
    if (box) {
      box.innerHTML = p.variants.map(function (v) {
        return '<button type="button" class="kp-size' + (v.id === pick.id ? ' active' : '') + (v.available ? '' : ' soldout') + '"' +
          ' data-kp-variant="' + v.id + '" data-price="' + v.price + '"' + (v.available ? '' : ' disabled') + '>' +
          esc(String(v.title).toLowerCase()) + '</button>';
      }).join('');
    }
    var sel = $('[data-kp-sticky-size]');
    if (sel) {
      sel.innerHTML = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === pick.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
          esc(String(v.title).toLowerCase()) + '</option>';
      }).join('');
    }
    return pick;
  }

  function setColour(handle) {
    var to = byHandle(handle), from = byHandle(activeHandle);
    if (to < 0 || handle === activeHandle) return;
    var p = group[to];
    var keep = (function () {
      var a = $('[data-kp-sizes] .kp-size.active');
      return a ? a.textContent.trim().toUpperCase() : null;
    })();
    activeHandle = handle;

    swipeTo(p, to > from ? 1 : -1);
    renderThumbs(p);
    var v = renderSizes(p, keep);
    setVariant(String(v.id), v.price);

    var t = $('[data-kp-title]'); if (t) t.textContent = p.title;
    var cmp = $('[data-kp-compare]');
    if (cmp) { cmp.hidden = !(p.compare > v.price); cmp.textContent = money(p.compare); }
    var nm = $('[data-kp-colour-name]'); if (nm) nm.textContent = p.colour;
    var desc = $('[data-kp-desc]'); if (desc && p.description) desc.innerHTML = p.description;
    var sn = $('[data-kp-sticky-name]'); if (sn) sn.textContent = p.title;
    var si = $('[data-kp-sticky-img]'); if (si && p.images[0]) si.src = p.images[0].thumb;

    $$('[data-kp-add]').forEach(function (b) {
      b.disabled = !p.available;
      if (b.closest('.kp-atc')) b.textContent = p.available ? 'add to bag' : 'sold out';
    });
    $$('[data-kp-colour]').forEach(function (b) {
      var on = b.getAttribute('data-kp-colour') === handle;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Complete-the-set card (main-product.liquid set_upsell_swap) follows the colour:
    // point it at this colour's set, or hide it if that set is sold out.
    var su = $('[data-kp-set-upsell]');
    if (su) {
      var suList = null, suT = null;
      try { suList = JSON.parse($('[data-kp-set-upsell-map]').textContent); } catch (e) { suList = null; }
      for (var si2 = 0; suList && si2 < suList.length; si2++) if (suList[si2].handle === handle) suT = suList[si2];
      su.style.display = suT ? '' : 'none';
      if (suT) {
        $$('[data-kp-set-upsell-link]').forEach(function (a) { a.setAttribute('href', suT.url); });
        var suImg = $('[data-kp-set-upsell-img]'); if (suImg) { suImg.src = suT.img; suImg.alt = suT.title; }
        var suNm = $('[data-kp-set-upsell-nm]'); if (suNm) suNm.textContent = suT.title;
      }
    }

    // The URL follows the colour (keeping ?view=k1-set and any ad UTMs), so a
    // refresh or a shared link reopens on the colour they were looking at.
    if (window.history && history.replaceState) {
      try { history.replaceState(history.state, '', p.url + location.search + location.hash); } catch (e) {}
    }
  }

  // Warm the other colours' lead photos once the page is idle, so the first
  // swipe is instant instead of waiting on the network.
  if (group && group.length > 1) {
    var warm = function () {
      group.forEach(function (p) { if (p.handle !== activeHandle && p.images[0]) { var i = new Image(); i.src = p.images[0].src; } });
    };
    window.addEventListener('load', function () {
      (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(warm);
    });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kp-thumb]');
    if (t) {
      var main = $('#kpMainImg');
      if (main) main.src = t.getAttribute('data-kp-thumb');
      $$('.kp-thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      return;
    }
    var c = e.target.closest('[data-kp-colour]');
    if (c) { setColour(c.getAttribute('data-kp-colour')); return; }
    var s = e.target.closest('[data-kp-sizes] .kp-size');
    if (s) {
      if (s.disabled) return;
      markSize(s.getAttribute('data-kp-variant'));
      setVariant(s.getAttribute('data-kp-variant'), parseInt(s.getAttribute('data-price'), 10));
      var ss = $('[data-kp-sticky-size]'); if (ss) ss.value = s.getAttribute('data-kp-variant');
      return;
    }
    var a = e.target.closest('[data-kp-add]');
    if (a) {
      if (a.disabled) return;
      var id = a.getAttribute('data-variant') || selected;
      if (window.kpAddVariant) window.kpAddVariant(id, 1);
      return;
    }
    var modal = $('#kpSizeModal');
    if (e.target.closest('[data-kp-sizeguide]')) { if (modal) modal.classList.add('open'); return; }
    if (e.target.closest('[data-kp-sizeguide-close]')) { if (modal) modal.classList.remove('open'); }
  });

  d.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-kp-sticky-size]');
    if (!sel) return;
    var id = sel.value;
    var btn = d.querySelector('[data-kp-sizes] .kp-size[data-kp-variant="' + id + '"]');
    setVariant(id, btn ? parseInt(btn.getAttribute('data-price'), 10) : null);
    markSize(id);
  });

  var sticky = $('#kpStickyAtc'), mainAtc = $('.kp-atc [data-kp-add]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var dr = $('#kpDrawer');
      var drawerOpen = dr && dr.classList.contains('open');
      sticky.classList.toggle('show', !e.isIntersecting && !drawerOpen);
    }, { threshold: 0 }).observe(mainAtc);
  }
})();
